<template>
    <div>
        <header-portrate />

    <div style="margin-bottom:70px;">
        <bread-crumbs :items="items"></bread-crumbs>
        <tabs-comp :tabs="tabs" />

        <v-row class="mainrow m-2" :style="`direction:`+lang.dir+`;margin-top:100px !important;`">
            <v-col cols="12">
                <h4 style="font-weight:bold">{{ lang.zi_title }}</h4>
                <div class="zi-tabs">
                    <v-btn v-for="t in pageTabs" :key="t.key" small :class="activeTab == t.key ? 'zi-tab-on' : 'zi-tab-off'" @click="openTab(t.key)">{{ t.text }}</v-btn>
                </div>
            </v-col>

            <!-- ============================================================ status -->
            <v-col cols="12" v-if="activeTab == 'status'">
                <div v-if="!status.schema_ready" class="zi-alert zi-bad">{{ lang.zi_schema_missing }}</div>
                <template v-else>
                    <div v-if="!status.key_configured" class="zi-alert zi-bad">{{ lang.zi_key_missing }}</div>
                    <div v-if="status.mode == 'central'" class="zi-alert zi-warn">{{ lang.zi_central_note }}</div>
                    <div v-if="status.oldest_unreported && status.oldest_unreported.overdue" class="zi-alert zi-bad">
                        {{ lang.zi_overdue }} &mdash; {{ lang.zi_oldest }}: {{ status.oldest_unreported.invoice_number }} ({{ status.oldest_unreported.hours_old }} {{ lang.zi_hours_old }})
                    </div>

                    <v-row>
                        <v-col cols="12" md="3">{{ lang.zi_mode }}</v-col>
                        <v-col cols="12" md="3"><b>{{ modeText(status.mode) }}</b></v-col>
                        <v-col cols="12" md="3">{{ lang.zi_environment }}</v-col>
                        <v-col cols="12" md="3">
                            <b-form-select class="selborder" :options="environments" v-model="environment" @change="saveEnvironment" />
                        </v-col>
                    </v-row>

                    <v-row v-if="canActivate">
                        <v-col cols="12" class="text-end">
                            <v-btn style="background:green;color:#fff" @click="confirm(lang.zi_activate_confirm, activate)">{{ lang.zi_activate }}</v-btn>
                        </v-col>
                    </v-row>

                    <h5 class="zi-h">{{ lang.zi_devices }}</h5>
                    <div v-if="status.devices.length == 0">{{ lang.zi_no_devices }}</div>
                    <table v-else class="table table-bordered table-sm">
                        <thead><tr>
                            <th>{{ lang.zi_branch }}</th><th>{{ lang.zi_environment }}</th><th>{{ lang.zi_status }}</th><th>{{ lang.zi_source }}</th>
                            <th>{{ lang.zi_seller_name_en }}</th><th>{{ lang.zi_cert_expires }}</th><th>{{ lang.zi_icv }}</th><th></th>
                        </tr></thead>
                        <tbody>
                            <tr v-for="d in status.devices" :key="d.id">
                                <td>{{ d.branchid }}</td>
                                <td>{{ envText(d.environment) }}</td>
                                <td>{{ lang['zi_st_' + d.status] || d.status }}</td>
                                <td>{{ d.source }}</td>
                                <td>{{ d.seller_name }} ({{ d.seller_vat }})</td>
                                <td :class="d.cert_days_left !== null && d.cert_days_left < 30 ? 'zi-text-bad' : ''">
                                    {{ d.cert_expires_at }}<span v-if="d.cert_days_left !== null"> &mdash; {{ d.cert_days_left }} {{ lang.zi_days_left }}</span>
                                </td>
                                <td>{{ d.icv }}</td>
                                <td>
                                    <template v-if="d.status == 'active'">
                                        <b-form-input v-model="renewOtp[d.id]" class="inborder zi-otp" :placeholder="lang.zi_otp" />
                                        <v-btn x-small @click="renew(d)">{{ lang.zi_renew }}</v-btn>
                                    </template>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <h5 class="zi-h">{{ lang.zi_counts }}</h5>
                    <span v-for="(n, s) in status.counts" :key="s" :class="'zi-badge zi-' + s" style="cursor:pointer" @click="showStatus(s)">
                        {{ lang['zi_st_' + s] || s }}: {{ n }}
                    </span>

                    <h5 class="zi-h">{{ lang.zi_zero_title }}</h5>
                    <small>{{ lang.zi_zero_help }}</small>
                    <v-row>
                        <v-col cols="12" md="2"><b-form-select class="selborder" :options="zeroCategories" v-model="zero.category" /></v-col>
                        <v-col cols="12" md="3"><b-form-input class="inborder" v-model="zero.code" :placeholder="lang.zi_zero_code" /></v-col>
                        <v-col cols="12" md="5"><b-form-input class="inborder" v-model="zero.text" :placeholder="lang.zi_zero_text" /></v-col>
                        <v-col cols="12" md="2"><v-btn small @click="saveZero">{{ lang.zi_save }}</v-btn></v-col>
                    </v-row>
                </template>
            </v-col>

            <!-- ============================================================ profile -->
            <v-col cols="12" v-if="activeTab == 'profile'">
                <small>{{ lang.zi_profile_help }}</small>
                <div v-if="profileMissing" class="zi-alert zi-warn">{{ profileMissing }}</div>
                <v-row>
                    <v-col cols="12" md="6" v-for="f in profileFields" :key="f.key">
                        <label>{{ f.label }}</label>
                        <b-form-input class="inborder" v-model="profile[f.key]" :dir="f.ltr ? 'ltr' : ''" />
                    </v-col>
                </v-row>
                <div class="text-end"><v-btn style="background:green;color:#fff" @click="saveProfile">{{ lang.zi_save }}</v-btn></div>
            </v-col>

            <!-- ============================================================ connect -->
            <v-col cols="12" v-if="activeTab == 'connect'">
                <div v-if="!status.key_configured" class="zi-alert zi-bad">{{ lang.zi_key_missing }}</div>
                <v-row>
                    <v-col cols="12" md="2">{{ lang.zi_branch }}</v-col>
                    <v-col cols="12" md="2"><b-form-input class="inborder" type="number" min="1" v-model="connect.branchid" @change="pickDevice" /></v-col>
                    <v-col cols="12" md="2">{{ lang.zi_environment }}</v-col>
                    <v-col cols="12" md="3"><b-form-select class="selborder" :options="environments" v-model="connect.environment" @change="pickDevice" /></v-col>
                </v-row>

                <div :class="'zi-step ' + stepClass(1)">
                    <b>1. {{ lang.zi_step1 }}</b>
                    <v-btn x-small :disabled="busy" @click="step('create_csr', {branchid: +connect.branchid, environment: connect.environment})">{{ lang.zi_run }}</v-btn>
                </div>
                <div :class="'zi-step ' + stepClass(2)">
                    <b>2. {{ lang.zi_step2 }}</b>
                    <b-form-input class="inborder zi-otp" v-model="connect.otp" :placeholder="lang.zi_otp" />
                    <v-btn x-small :disabled="busy || !device" @click="step('compliance_csid', {egs_id: device.id, otp: connect.otp})">{{ lang.zi_run }}</v-btn>
                </div>
                <div :class="'zi-step ' + stepClass(3)">
                    <b>3. {{ lang.zi_step3 }}</b>
                    <v-btn x-small :disabled="busy || !device || device.status == 'draft'" @click="runChecks">{{ lang.zi_run }}</v-btn>
                    <div v-for="c in checks" :key="c.label" :class="c.passed ? 'zi-text-good' : 'zi-text-bad'">
                        {{ c.passed ? lang.zi_passed : lang.zi_failed }} &mdash; {{ c.label }} ({{ c.status }}) {{ c.message }}
                        <small v-for="w in c.warnings" :key="w" style="display:block">{{ w }}</small>
                    </div>
                </div>
                <div :class="'zi-step ' + stepClass(4)">
                    <b>4. {{ lang.zi_step4 }}</b>
                    <v-btn x-small :disabled="busy || !device || device.status == 'draft'" @click="step('production_csid', {egs_id: device.id})">{{ lang.zi_run }}</v-btn>
                    <div v-if="device && device.status == 'active'" class="zi-text-good">{{ lang.zi_connected }}</div>
                </div>
            </v-col>

            <!-- ============================================================ documents -->
            <v-col cols="12" v-if="activeTab == 'documents'">
                <v-row>
                    <v-col cols="12" md="2"><b-form-select class="selborder" :options="statusFilter" v-model="docs.filter.status" @change="loadDocs(1)" /></v-col>
                    <v-col cols="12" md="2"><b-form-select class="selborder" :options="typeFilter" v-model="docs.filter.doc_type" @change="loadDocs(1)" /></v-col>
                    <v-col cols="12" md="2"><b-form-input class="inborder" type="date" v-model="docs.filter.from" @change="loadDocs(1)" /></v-col>
                    <v-col cols="12" md="2"><b-form-input class="inborder" type="date" v-model="docs.filter.to" @change="loadDocs(1)" /></v-col>
                    <v-col cols="12" md="3"><b-form-input class="inborder" v-model="docs.filter.search" :placeholder="lang.zi_search" @change="loadDocs(1)" /></v-col>
                </v-row>
                <table class="table table-bordered table-sm">
                    <thead><tr>
                        <th>{{ lang.zi_date }}</th><th>{{ lang.zi_doc_type }}</th><th>{{ lang.zi_number }}</th><th>{{ lang.zi_subtype }}</th>
                        <th>{{ lang.zi_icv }}</th><th>{{ lang.zi_status }}</th><th>{{ lang.zi_attempts }}</th><th>{{ lang.zi_message }}</th><th></th>
                    </tr></thead>
                    <tbody>
                        <tr v-for="d in docs.rows" :key="d.id">
                            <td>{{ d.created_at }}</td>
                            <td>{{ d.doc_type == 'return' ? lang.zi_return : lang.zi_invoice }} <small v-if="d.invoice_type != 388">({{ d.invoice_type }})</small></td>
                            <td>{{ d.invoice_number }}</td>
                            <td>{{ d.subtype == 'standard' ? lang.zi_standard : (d.subtype == 'simplified' ? lang.zi_simplified : '') }}</td>
                            <td>{{ d.icv }}</td>
                            <td><span :class="'zi-badge zi-' + d.status">{{ lang['zi_st_' + d.status] || d.status }}</span></td>
                            <td>{{ d.attempts }}</td>
                            <td style="max-width:360px;font-size:12px">
                                <div v-if="d.last_error">{{ d.last_error }}</div>
                                <div v-for="w in d.warnings" :key="'w' + w" class="zi-text-warn">{{ w }}</div>
                            </td>
                            <td style="white-space:nowrap">
                                <v-btn x-small v-if="['pending','failed','unsigned'].indexOf(d.status) > -1" @click="resend(d)">{{ lang.zi_resend }}</v-btn>
                                <v-btn x-small v-if="['unsigned','imported'].indexOf(d.status) == -1" @click="downloadXml(d)">{{ lang.zi_xml }}</v-btn>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="text-center">
                    <v-btn x-small :disabled="docs.page <= 1" @click="loadDocs(docs.page - 1)">{{ lang.zi_prev }}</v-btn>
                    {{ docs.page }} / {{ Math.max(1, Math.ceil(docs.total / docs.size)) }}
                    <v-btn x-small :disabled="docs.page * docs.size >= docs.total" @click="loadDocs(docs.page + 1)">{{ lang.zi_next }}</v-btn>
                </div>
            </v-col>
        </v-row>

        
    </div>
        <Footer />
    </div>
</template>

<script>
import axios from 'axios'
import BreadCrumbs from '@/components/breadCrumbs.vue';
import TabsComp from '@/components/tabsComp.vue';
import HeaderPortrate from '@/components/Header-Portrate.vue';
import Footer from '@/components/Footer.vue';
import {SnotifyPosition} from 'vue-snotify';
export default{
    components: {BreadCrumbs, TabsComp, HeaderPortrate, Footer},
    data() {
        return {
            activeTab: 'status',
            busy: false,
            status: {schema_ready: true, key_configured: true, mode: '', environment: 'core', devices: [], counts: {}, oldest_unreported: null},
            environment: 'core',
            zero: {category: '', code: '', text: ''},
            renewOtp: {},
            profile: {},
            profileMissing: '',
            connect: {branchid: 1, environment: 'simulation', otp: ''},
            device: null,
            checks: [],
            docs: {rows: [], total: 0, page: 1, size: 50, filter: {status: '', doc_type: '', from: '', to: '', search: ''}},
        }
    },
    methods: {
        // Every call goes to index.php type=zatcaInapp (php/includes/zatca/Api.php).
        // Resolves to the result, or to null after showing the error.
        call(action, payload){
            const post = new FormData();
            post.append("type", 'zatcaInapp');
            post.append('defBranch', localStorage.getItem('defBranch'));
            post.append('financeYear', localStorage.getItem('financeYear'));
            post.append("auth", this.$cookies.get(this.$COOKIEPhase));
            post.append("data[action]", action);
            post.append("data[payload]", JSON.stringify(payload || {}));
            this.busy = true;
            return axios.post(this.$SAMCOTEC.r_path, post).then((response) => {
                this.busy = false;
                const res = response.data;
                if(!res.error || res.error.number != 200){
                    this.alert(res.error ? res.error.message : 'error');
                    return null;
                }
                return res.results.data;
            }, (error) => {
                this.busy = false;
                this.alert(String(error));
                return null;
            });
        },
        alert(message){
            this.$snotify.error(message, this.lang.alert, {
                timeout: 1000000,
                showProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                position: SnotifyPosition.centerCenter,
                buttons: [{text: this.lang.zi_close, action: (toast) => { this.$snotify.remove(toast.id); }}]
            });
        },
        notice(message){
            this.$snotify.success(message, '', {timeout: 3000, showProgressBar: false, position: SnotifyPosition.centerTop});
        },
        confirm(message, then){
            this.$snotify.error(message, this.lang.alert, {
                timeout: 1000000,
                showProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                position: SnotifyPosition.centerCenter,
                buttons: [
                    {text: this.lang.zi_cancel, action: (toast) => { this.$snotify.remove(toast.id); }},
                    {text: this.lang.zi_confirm, action: (toast) => { this.$snotify.remove(toast.id); then(); }},
                ]
            });
        },
        openTab(key){
            this.activeTab = key;
            if(key == 'status' || key == 'connect') this.loadStatus();
            if(key == 'profile') this.loadProfile();
            if(key == 'documents') this.loadDocs(1);
        },
        loadStatus(){
            return this.call('status').then((data) => {
                if(!data) return;
                this.status = data;
                this.environment = data.environment;
                this.zero = {category: data.zero_category, code: data.zero_reason_code, text: data.zero_reason_text};
                this.pickDevice();
            });
        },
        pickDevice(){
            this.device = (this.status.devices || []).find((d) => d.branchid == this.connect.branchid && d.environment == this.connect.environment) || null;
        },
        saveEnvironment(){
            this.call('settings_save', {environment: this.environment}).then((data) => {
                if(!data){
                    this.environment = this.status.environment;
                    return;
                }
                this.status = data;
                this.notice(this.lang.zi_saved);
            });
        },
        saveZero(){
            this.call('settings_save', {zero_category: this.zero.category, zero_reason_code: this.zero.code, zero_reason_text: this.zero.text})
                .then((data) => { if(data) this.notice(this.lang.zi_saved); });
        },
        activate(){
            this.call('activate').then((data) => {
                if(!data) return;
                this.status = data;
                this.notice(this.lang.zi_saved);
            });
        },
        renew(d){
            this.call('renew', {egs_id: d.id, otp: this.renewOtp[d.id] || ''}).then((data) => {
                if(!data) return;
                this.notice(this.lang.zi_saved);
                this.loadStatus();
            });
        },
        showStatus(s){
            this.docs.filter.status = s;
            this.openTab('documents');
        },
        loadProfile(){
            this.call('profile_get').then((data) => { if(data) this.profile = data; });
        },
        saveProfile(){
            this.call('profile_save', this.profile).then((data) => {
                if(!data) return;
                this.profile = data;
                this.profileMissing = data.complete ? '' : data.missing;
                this.notice(data.complete ? this.lang.zi_profile_complete : this.lang.zi_saved);
            });
        },
        step(action, payload){
            this.call(action, payload).then((data) => {
                if(!data) return;
                this.device = data;
                this.connect.otp = '';
                this.loadStatus();
            });
        },
        runChecks(){
            this.checks = [];
            this.call('compliance_checks', {egs_id: this.device.id}).then((data) => { if(data) this.checks = data.checks; });
        },
        stepClass(n){
            const s = this.device ? this.device.status : '';
            const done = {draft: 1, compliance: 2, active: 4}[s] || 0;
            if(n <= done) return 'zi-step-done';
            return n == done + 1 || (n == 3 && done == 2) ? 'zi-step-next' : '';
        },
        loadDocs(page){
            const payload = Object.assign({page: page}, this.docs.filter);
            this.call('documents', payload).then((data) => {
                if(!data) return;
                this.docs.rows = data.rows;
                this.docs.total = data.total;
                this.docs.page = data.page;
                this.docs.size = data.size;
            });
        },
        resend(d){
            this.call('resend', {id: d.id}).then((data) => {
                if(!data) return;
                this.notice(this.lang['zi_st_' + data.status] || data.status);
                this.loadDocs(this.docs.page);
            });
        },
        downloadXml(d){
            this.call('xml', {id: d.id}).then((data) => {
                if(!data) return;
                const url = window.URL.createObjectURL(new Blob([data.xml], {type: 'application/xml'}));
                const a = document.createElement('a');
                a.href = url;
                a.download = data.file_name;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            });
        },
        modeText(mode){
            return this.lang['zi_mode_' + mode] || mode;
        },
        envText(env){
            return env == 'simulation' ? this.lang.zi_env_simulation : this.lang.zi_env_core;
        },
    },

    created() {
        this.loadStatus();
    },
    computed: {
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki)  == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }
            else if(this.$store.state.deflang == 'ur'){
                return this.$store.state.lang.ur;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        pageTabs: function(){
            return [
                {key: 'status', text: this.lang.zi_tab_status},
                {key: 'profile', text: this.lang.zi_tab_profile},
                {key: 'connect', text: this.lang.zi_tab_connect},
                {key: 'documents', text: this.lang.zi_tab_documents},
            ];
        },
        environments: function(){
            return [
                {text: this.lang.zi_env_simulation, value: 'simulation'},
                {text: this.lang.zi_env_core, value: 'core'},
            ];
        },
        zeroCategories: function(){
            return [
                {text: '-', value: ''},
                {text: 'Z - Zero rated', value: 'Z'},
                {text: 'E - Exempt', value: 'E'},
                {text: 'O - Out of scope', value: 'O'},
            ];
        },
        canActivate: function(){
            if(this.status.mode == 'inapp' || this.status.mode == 'central') return false;
            return (this.status.devices || []).some((d) => d.status == 'active' && d.environment == this.status.environment);
        },
        profileFields: function(){
            return [
                {key: 'seller_name', label: this.lang.zi_seller_name_en, ltr: true},
                {key: 'seller_name_ar', label: this.lang.zi_seller_name_ar},
                {key: 'seller_vat', label: this.lang.zi_vat, ltr: true},
                {key: 'seller_crn', label: this.lang.zi_crn, ltr: true},
                {key: 'street', label: this.lang.zi_street, ltr: true},
                {key: 'building_number', label: this.lang.zi_building, ltr: true},
                {key: 'secondary_number', label: this.lang.zi_secondary, ltr: true},
                {key: 'district', label: this.lang.zi_district, ltr: true},
                {key: 'city', label: this.lang.zi_city, ltr: true},
                {key: 'postal_code', label: this.lang.zi_postal, ltr: true},
                {key: 'business_category', label: this.lang.zi_category, ltr: true},
            ];
        },
        statusFilter: function(){
            const list = ['needs_data', 'pending', 'failed', 'rejected', 'unsigned', 'reported', 'cleared', 'imported'];
            return [{text: this.lang.zi_all, value: ''}].concat(list.map((s) => ({text: this.lang['zi_st_' + s], value: s})));
        },
        typeFilter: function(){
            return [
                {text: this.lang.zi_all, value: ''},
                {text: this.lang.zi_invoice, value: 'invoice'},
                {text: this.lang.zi_return, value: 'return'},
            ];
        },
        items: function() {
            return {
                    text: this.lang.system_settings,
                    disabled: true,
                    to: '/settings/system-settings',
                }
        },
        tabs: function() {
            const menu = this.$store.getters['state'].menu;
            const license = this.$store.getters['state'].licenseType.activemenu;
            const alicense = this.$store.getters['state'].licenseType
            let currentMenu = menu[license];
            if(!license){
              return false;
            }
            let cMenu = {main: {},sub:[]};
            Object.values(currentMenu).forEach(value =>{
            const cM = localStorage.getItem('currentMenu');
            if(value.main.index == cM){
                cMenu = value.sub;
            }else if(cM == null && value.main.index == 1){
                cMenu = value.sub;
            }
            });

            let t = []
            Object.values(cMenu).forEach(value =>{

                if(this.$route.path == value.href){
                    value.class = "mytab";
                }else{
                    value.class = "mytab4";
                }
                if(this.lang.langname == 'ar'){
                    value.name = value.arname
                }else{
                    value.name = value.enname
                }
                for(let i =0; i< value.groupid.length;i++){
                    if(value.groupid[i] == this.$store.getters['state'].group_id){
                    if(alicense[value.perms[0]] || value.perms[0] == 'any')
                        t.push(value)
                    }
                }

            })

            return t;
        }
    },
}
</script>

<style scoped>
.zi-tabs { margin-top: 8px; }
.zi-tabs .v-btn { margin: 0 4px 4px 0; }
.zi-tab-on { background: #0a6ebd !important; color: #fff !important; }
.zi-tab-off { background: #eee !important; }
.zi-h { margin-top: 18px; font-weight: bold; }
.zi-alert { padding: 8px 12px; border-radius: 6px; margin: 6px 0; }
.zi-bad { background: #fde8e8; color: #9b1c1c; }
.zi-warn { background: #fdf6e3; color: #8a5a00; }
.zi-text-bad { color: #c0392b; }
.zi-text-good { color: #1e7e34; }
.zi-text-warn { color: #8a5a00; }
.zi-otp { display: inline-block; width: 110px; margin: 0 6px; }
.zi-step { border: 1px solid #ddd; border-radius: 6px; padding: 8px 12px; margin: 8px 0; }
.zi-step-done { border-color: #1e7e34; background: #f0faf2; }
.zi-step-next { border-color: #0a6ebd; }
.zi-badge { display: inline-block; padding: 2px 8px; border-radius: 10px; margin: 2px 4px 2px 0; font-size: 12px; background: #eee; }
.zi-reported, .zi-cleared { background: #d4edda; color: #155724; }
.zi-imported { background: #e2e3e5; color: #383d41; }
.zi-pending { background: #d1ecf1; color: #0c5460; }
.zi-failed, .zi-unsigned { background: #fff3cd; color: #856404; }
.zi-rejected { background: #f8d7da; color: #721c24; }
</style>
